import React, { useEffect, useState } from "react";
import CommonButton from "../../Common/Button";
import Basicinformation from "../../Drawer/Basicinformatiom";
import API, { action } from "../../../Api";
import { CiCircleInfo } from "react-icons/ci";
import { Tooltip } from "antd";
import WeightHistory from "../../Drawer/WeightHistory";
import CattleTypeHistory from "../../Drawer/CattleTypeHistory";

function BasicInformation({ Selected, getCattleList, cattleList, handleCurrentCattleSelect }) {
  const [datails, setDetails] = useState(false);
  const [cattleDetails, setCattleDetails] = useState(null);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [selectedCattleId, setSeelctedCattleId] = useState(null);
  const [typeHistoryOpen, setTypeHistoryOpen] = useState(false);
  const Imageurl = process.env.REACT_APP_MAIN_URL + "uploads/";

  const handleclick = () => {
    setDetails((prevState) => {
      if (prevState) {
        getCattleList();
        if (Selected?.id) {
          getcattleDetails(Selected.id);
        }
      }
      return !prevState;
    });
  };

  const handleHistoryOpen = (id) => {
    setHistoryOpen(true);
    setSeelctedCattleId(id);
  };

  const handleTypeHistoryOpen = (id) => {
    setTypeHistoryOpen(true);
    setSeelctedCattleId(id);
  };

  const getcattleDetails = async (id) => {
    try {
      const result = await action(API.GET_CATTLE_DETAILS, {
        id: id,
        // id: Selected.id,
      });

      setCattleDetails(result.response.data);  
      handleCurrentCattleSelect(result.response.data)
      console.log(result.response.data,"result.response.data")
    } catch (error) {
      console.error("Error fetching cattletype data:", error);
    }
  };

  useEffect(() => {
    if (Selected?.id) {
      setCattleDetails(null);
      getcattleDetails(Selected.id);
    } else {
      setCattleDetails(null);
    }
  }, [Selected?.id]);

  return (
    <div className="basic-info-container">
      <div className="flex justify-between items-center">
        <p className="text-[#16A34A] font-plus-jakarta-sans text-sm  font-semibold leading-6">
          Enrollment
        </p>
        <CommonButton
          title="Edit"
          style={{
            fontSize: "12px",
            borderRadius: 10,
            backgroundColor: "#E3E3E3",
            color: "#2B2928",
            border: "none",
          }}
          onClick={handleclick}
        />
      </div>
      <div className="flex justify-between">
        {/* Left side content */}
        <div className="w-2/3">
          <div className="text-[#726C6C] font-plus-jakarta-sans text-xs font-semibold  flex flex-row items-center ">
            <div>
              <p>
                <strong>Cattle ID</strong>
              </p>
              <p>
                <strong>Cattle Type</strong>
              </p>
              <p>
                <strong>Date of Birth</strong>
              </p>
              <p>
                <strong>Gender</strong>
              </p>
              <p>
                <strong>Weight</strong>
              </p>
            </div>
            <div className="ml-10 text-[#0A0B0A] capitalize">
              <p>{cattleDetails?.cattle_id ? cattleDetails?.cattle_id : "--"}</p>
              <div className="flex gap-4">
                <p>
                  {cattleDetails?.CattleType?.cattle_type_name
                    ? cattleDetails?.CattleType?.cattle_type_name
                    : "--"}
                </p>
                <Tooltip title="Cattle Type History">
                  <div onClick={() => handleTypeHistoryOpen(cattleDetails.id)}>
                    <CiCircleInfo size={18} className="text-red-600" />
                  </div>
                </Tooltip>
              </div>

              <p>{cattleDetails?.dob ? cattleDetails?.dob : "--"}</p>
              <p>{cattleDetails?.gender ? cattleDetails?.gender : "--"}</p>
              <div className="flex gap-4">
                <p>{cattleDetails?.weight ? cattleDetails?.weight : "--"}</p>
                <Tooltip title="Weight History">
                  <div onClick={() => handleHistoryOpen(cattleDetails.id)}>
                    <CiCircleInfo size={18} className="text-red-600" />
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center mt-8">
            <p className="text-[#16A34A] font-plus-jakarta-sans text-sm font-semibold leading-6">
              Family Breed and Genetics
            </p>
            {/* <CommonButton title='Edit' style={{ fontSize: '12px', borderRadius: 10, backgroundColor: "#E3E3E3", color: "#2B2928", border: "none" }} /> */}
          </div>
          <div className="text-[#726C6C] font-plus-jakarta-sans text-xs font-semibold  flex flex-row items-center ">
            <div>
              <p>
                <strong>Fathered By</strong>
              </p>
              <p>
                <strong>Mothered By</strong>
              </p>
            </div>
            <div className="ml-10 text-[#0A0B0A] capitalize">
              <p>
                {cattleDetails?.Father?.cattle_id
                  ? cattleDetails?.Father?.cattle_id
                  : "--"}
              </p>
              <p>
                {cattleDetails?.Mother?.cattle_id
                  ? cattleDetails.Mother?.cattle_id
                  : "--"}
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center mt-8">
            <p className="text-[#16A34A] font-plus-jakarta-sans text-sm font-semibold leading-6">
              Additional Details
            </p>
            {/* <CommonButton title='Edit' style={{ fontSize: '12px', borderRadius: 10, backgroundColor: "#E3E3E3", color: "#2B2928", border: "none" }} /> */}
          </div>
          <div className="text-[#726C6C] font-plus-jakarta-sans text-xs font-semibold flex flex-row items-start capitalize">
            <div className="min-w-[120px]">
              <p>
                <strong>License Information</strong>
              </p>
              <p>
                <strong>Cooperation Number</strong>
              </p>
              <p>
                <strong>Additional Notes</strong>
              </p>
            </div>
            <div className="ml-10 text-[#0A0B0A] capitalize flex-1">
              <p className="break-words whitespace-normal">
                {cattleDetails?.licence_info ? cattleDetails?.licence_info : "--"}
              </p>
              <p className="break-words whitespace-normal">
                {cattleDetails?.corporation_no
                  ? cattleDetails?.corporation_no
                  : "--"}
              </p>
              <p className="break-words whitespace-normal">
                {cattleDetails?.notes
                  ? cattleDetails?.notes
                  : "--"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-2/3 flex justify-center items-start">
          {cattleDetails?.image ? (
            <img
              src={Imageurl + cattleDetails?.image}
              alt="Cattle"
              className="rounded-lg object-fit max-w-full max-h-96"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div
            className="w-96 h-96 bg-gray-200 rounded-lg flex items-center justify-center"
            style={{ display: cattleDetails?.image ? 'none' : 'flex' }}
          >
            <p className="text-gray-500">No Image</p>
          </div>
        </div>
      </div>
      <Basicinformation
        isOpen={datails}
        toggle={handleclick}
        details={Selected}
        cattleList={cattleList}
        getCattleList={getCattleList}
      />
      <WeightHistory
        isOpen={historyOpen}
        toggle={() => setHistoryOpen(false)}
        selectedItem={selectedCattleId}
        setSeelctedCattleId={setSeelctedCattleId}
      />
      <CattleTypeHistory
        isOpen={typeHistoryOpen}
        toggle={() => setTypeHistoryOpen(false)}
        selectedItem={selectedCattleId}
        setSeelctedCattleId={setSeelctedCattleId}
      />
    </div>
  );
}

export default BasicInformation;
